// ** Imports createContext function
import { createContext } from "react";

// ** Imports createContextualCan function
import { createContextualCan } from "@casl/react";
import { createMongoAbility } from "@casl/ability";

// ** Create Context
export const AbilityContext = createContext(createMongoAbility());

// ** Init Can Context
export const Can = createContextualCan(AbilityContext.Consumer);
